// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:44105/' | (string & {});
};

export const AccessRightCode = { PublicModelationsRead: 'PublicModelationsRead' } as const;

export type AccessRightCode = typeof AccessRightCode[keyof typeof AccessRightCode];

export const AccessRoleCode = {
    TenantAdmin: 'TenantAdmin',
    SysAdmin: 'SysAdmin',
    ApiClient: 'ApiClient'
} as const;

export type AccessRoleCode = typeof AccessRoleCode[keyof typeof AccessRoleCode];

export const AddressType = { Permanent: 'Permanent', Contact: 'Contact' } as const;

export type AddressType = typeof AddressType[keyof typeof AddressType];

/**
 * Wire shape of a single address value persisted in
 * `PathRunStep.FormResponseJson` when a field of
 * SystemFormDataType.Address is filled. Exposed in the
 * palette payload (as a nullable shape hint) purely so the OpenAPI
 * document carries the type — FE imports it for typed form values.
 * string? AddressValueDto.Country is free-form text (typically the localized
 * country name from CountryCatalog, but the user may type
 * any value such as "Slezsko" or "Morava"); the combobox just suggests
 * the catalog entries.
 */
export type AddressValueDto = {
    type: null | AddressType;
    street: null | string;
    houseNumber: null | string;
    city: null | string;
    zip: null | string;
    country: null | string;
};

export const AiCompletionErrorReason = {
    Unreachable: 'Unreachable',
    Timeout: 'Timeout',
    BadStatus: 'BadStatus',
    Unauthorized: 'Unauthorized',
    RateLimited: 'RateLimited',
    EmptyResponse: 'EmptyResponse',
    ContentFiltered: 'ContentFiltered'
} as const;

export type AiCompletionErrorReason = typeof AiCompletionErrorReason[keyof typeof AiCompletionErrorReason];

/**
 * RFC 7807 ProblemDetails extension where `errors` is a dictionary keyed by property/subject
 * (camelCase), each holding one or more typed ErrorDetail entries.
 */
export type ApiProblemDetails = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetail>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfAiCompletionErrorReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfAiCompletionErrorReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfAuthError = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfAuthError>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfCloseModuleRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfCloseModuleRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfClosePathRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfClosePathRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfCreateCustomModuleReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfCreateCustomModuleReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfCreatePathTemplateReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfCreatePathTemplateReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfDeleteCustomModuleReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfDeleteCustomModuleReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfDeletePathTemplateReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfDeletePathTemplateReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfGetFileContentError = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfGetFileContentError>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfModuleRunOperationReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfModuleRunOperationReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfPathStepOperationReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfPathStepOperationReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfReopenModuleRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfReopenModuleRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfRevokeModuleRunShareReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfRevokeModuleRunShareReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfRevokePathRunShareReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfRevokePathRunShareReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfSabApiErrorReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfSabApiErrorReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfSendShareEmailReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfSendShareEmailReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfShareModuleRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfShareModuleRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfSharePathRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfSharePathRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfStartModuleRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfStartModuleRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfStartPathRunReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfStartPathRunReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfUpdateCustomModuleReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfUpdateCustomModuleReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfUpdatePathTemplateReason = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfUpdatePathTemplateReason>;
    };
};

/**
 * OpenAPI-only typed counterpart of ApiProblemDetails: JSON-identical on the wire,
 * but exposes `ErrorDetail.Reason` as the constrained enum TReason
 * in the generated client. Use in `[ProducesResponseType&lt;ApiProblemDetails&lt;MyEnum&gt;&gt;(...)]`
 * for endpoints with a known reason enum.
 */
export type ApiProblemDetailsOfUploadFileError = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
    errors: {
        [key: string]: Array<ErrorDetailOfUploadFileError>;
    };
};

export const AuthError = { InvalidCredentials: 'InvalidCredentials', AccountWaitingForEmailConfirmation: 'AccountWaitingForEmailConfirmation' } as const;

export type AuthError = typeof AuthError[keyof typeof AuthError];

/**
 * Per-step field binding mode controlling how a path-run-scoped shared input
 * flows through a single step.
 */
export const BindingMode = {
    SharedReadWrite: 'SharedReadWrite',
    SharedReadLocalOverride: 'SharedReadLocalOverride',
    LocalOnly: 'LocalOnly'
} as const;

/**
 * Per-step field binding mode controlling how a path-run-scoped shared input
 * flows through a single step.
 */
export type BindingMode = typeof BindingMode[keyof typeof BindingMode];

export type BrokerSignInCommandRequest = {
    token: string;
    originUrl: string;
};

/**
 * One calculator's contribution to the prompt: its module key plus the labeled
 * inputs and (scalar) result metrics the frontend chose to send. Chart/time-series
 * arrays are intentionally omitted by the frontend.
 */
export type ClientSummaryCalculator = {
    moduleKey: ModuleKey;
    inputs: Array<ClientSummaryValue>;
    outputs: Array<ClientSummaryValue>;
};

/**
 * Scope of an AI client-summary generation request.
 */
export const ClientSummaryScope = { Module: 'Module', Path: 'Path' } as const;

/**
 * Scope of an AI client-summary generation request.
 */
export type ClientSummaryScope = typeof ClientSummaryScope[keyof typeof ClientSummaryScope];

/**
 * One labeled, already-formatted value. Built on the frontend (which owns the Czech
 * labels and number/money formatters) so the backend can assemble a readable prompt
 * without duplicating per-field labels or formatting.
 */
export type ClientSummaryValue = {
    label: string;
    value: string;
};

export const CloseModuleRunReason = {
    RunNotFound: 'RunNotFound',
    AlreadyClosed: 'AlreadyClosed',
    OutputsNotComputed: 'OutputsNotComputed'
} as const;

export type CloseModuleRunReason = typeof CloseModuleRunReason[keyof typeof CloseModuleRunReason];

export const ClosePathRunReason = { RunNotFound: 'RunNotFound', AlreadyClosed: 'AlreadyClosed' } as const;

export type ClosePathRunReason = typeof ClosePathRunReason[keyof typeof ClosePathRunReason];

export type ClosePathRunResult = {
    /**
     * PathRunID – protected ID as string
     */
    effectivePathRunID: string;
    forked: boolean;
    versionNumber: number;
};

/**
 * Where a modeling module's calculation runs. Declared per module via a
 * metadata attribute on the ModuleKey enum member. The
 * catalog endpoint surfaces this so the FE knows whether to compute
 * locally or call a server-side recompute.
 */
export const ComputeLocation = { Frontend: 'Frontend', Backend: 'Backend' } as const;

/**
 * Where a modeling module's calculation runs. Declared per module via a
 * metadata attribute on the ModuleKey enum member. The
 * catalog endpoint surfaces this so the FE knows whether to compute
 * locally or call a server-side recompute.
 */
export type ComputeLocation = typeof ComputeLocation[keyof typeof ComputeLocation];

/**
 * ISO 3166-1 alpha-2 country code. Used as the typed value of the
 * `country` sub-field of a structured address (see
 * SystemFormDataType.Address). Member names are the
 * two-letter alpha-2 codes themselves so the OpenAPI document carries
 * stable, well-known values consumable by any client.
 */
export const CountryCode = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AX: 'AX',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BL: 'BL',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BQ: 'BQ',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CW: 'CW',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MF: 'MF',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    SS: 'SS',
    ST: 'ST',
    SV: 'SV',
    SX: 'SX',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
} as const;

/**
 * ISO 3166-1 alpha-2 country code. Used as the typed value of the
 * `country` sub-field of a structured address (see
 * SystemFormDataType.Address). Member names are the
 * two-letter alpha-2 codes themselves so the OpenAPI document carries
 * stable, well-known values consumable by any client.
 */
export type CountryCode = typeof CountryCode[keyof typeof CountryCode];

/**
 * One country option exposed to the address combobox in the form viewer.
 */
export type CountryOptionDto = {
    code: CountryCode;
    name: string;
};

export type CreateCustomModuleCommandRequest = {
    name: string;
    description: null | string;
    kind: CustomModuleKind;
    /**
     * FileID – protected ID as string
     */
    fileID: null | string;
    scope: OwnershipScope;
    definition: null | FormDefinition;
};

export const CreateCustomModuleReason = {
    NotAuthenticated: 'NotAuthenticated',
    InvalidScope: 'InvalidScope',
    MissingFileForPdfKind: 'MissingFileForPdfKind',
    FileNotFound: 'FileNotFound',
    MissingDefinitionForFormKind: 'MissingDefinitionForFormKind',
    InvalidDefinition: 'InvalidDefinition',
    FormHasNoFields: 'FormHasNoFields',
    FileMustBeNullForFormKind: 'FileMustBeNullForFormKind',
    DefinitionMustBeNullForPdfKind: 'DefinitionMustBeNullForPdfKind'
} as const;

export type CreateCustomModuleReason = typeof CreateCustomModuleReason[keyof typeof CreateCustomModuleReason];

export type CreateCustomModuleResult = {
    /**
     * CustomModuleID – protected ID as string
     */
    customModuleID: string;
};

export type CreatePathTemplateCommandRequest = {
    name: string;
    description: null | string;
    scope: OwnershipScope;
    steps: Array<PathTemplateStepInput>;
};

export const CreatePathTemplateReason = {
    StepKindNotSupportedYet: 'StepKindNotSupportedYet',
    NotAuthenticated: 'NotAuthenticated',
    InvalidScope: 'InvalidScope'
} as const;

export type CreatePathTemplateReason = typeof CreatePathTemplateReason[keyof typeof CreatePathTemplateReason];

export type CreatePathTemplateResult = {
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID: string;
};

/**
 * Catalog of advisor-authored custom field types available in the form
 * builder palette ("Vlastní prvky"). Code-first enum — new kinds are
 * added here as the builder grows. Today only CustomFieldKind.ShortText
 * ships; the enum is designed to accept LongText, Number, Date, Select,
 * Radio … without breaking the persisted FormDefinition
 * JSON schema.
 */
export const CustomFieldKind = { ShortText: 'ShortText' } as const;

/**
 * Catalog of advisor-authored custom field types available in the form
 * builder palette ("Vlastní prvky"). Code-first enum — new kinds are
 * added here as the builder grows. Today only CustomFieldKind.ShortText
 * ships; the enum is designed to accept LongText, Number, Date, Select,
 * Radio … without breaking the persisted FormDefinition
 * JSON schema.
 */
export type CustomFieldKind = typeof CustomFieldKind[keyof typeof CustomFieldKind];

/**
 * One custom field-type option exposed to the form-builder palette
 * ("Vlastní prvky"). All defined CustomFieldKind values
 * are returned; the FE renders labels via its translation dictionary.
 */
export type CustomFieldOptionDto = {
    kind: CustomFieldKind;
};

export type CustomModuleDetailDto = {
    /**
     * CustomModuleID – protected ID as string
     */
    customModuleID: string;
    name: string;
    description?: null | string;
    kind: CustomModuleKind;
    scope: OwnershipScope;
    /**
     * UserID – protected ID as string
     */
    ownerUserID?: null | string;
    /**
     * TenantID – protected ID as string
     */
    ownerTenantID?: null | string;
    /**
     * UserID – protected ID as string
     */
    createdByUserID: string;
    /**
     * FileID – protected ID as string
     */
    fileID?: null | string;
    filePublicToken?: null | string;
    fileOriginalFileName?: null | string;
    fileMimeType?: null | string;
    fileSizeBytes?: null | number;
    definition?: null | FormDefinition;
};

export const CustomModuleKind = { Pdf: 'Pdf', Form: 'Form' } as const;

export type CustomModuleKind = typeof CustomModuleKind[keyof typeof CustomModuleKind];

export type CustomModuleListItemDto = {
    /**
     * CustomModuleID – protected ID as string
     */
    customModuleID: string;
    name: string;
    description?: null | string;
    kind: CustomModuleKind;
    scope: OwnershipScope;
    /**
     * UserID – protected ID as string
     */
    ownerUserID?: null | string;
    /**
     * TenantID – protected ID as string
     */
    ownerTenantID?: null | string;
    /**
     * UserID – protected ID as string
     */
    createdByUserID: string;
    filePublicToken?: null | string;
    fileOriginalFileName?: null | string;
    fileSizeBytes?: null | number;
    formFieldCount?: null | number;
};

export const DeleteCustomModuleReason = {
    NotAuthenticated: 'NotAuthenticated',
    ModuleNotFound: 'ModuleNotFound',
    NotOwner: 'NotOwner',
    InUse: 'InUse'
} as const;

export type DeleteCustomModuleReason = typeof DeleteCustomModuleReason[keyof typeof DeleteCustomModuleReason];

export const DeletePathTemplateReason = {
    TemplateNotFound: 'TemplateNotFound',
    NotOwner: 'NotOwner',
    NotAuthenticated: 'NotAuthenticated'
} as const;

export type DeletePathTemplateReason = typeof DeletePathTemplateReason[keyof typeof DeletePathTemplateReason];

export type EntityListOfCustomModuleListItemDto = {
    offset: number;
    limit: number;
    totalCount: number;
    items: null | Array<CustomModuleListItemDto>;
};

export type EntityListOfModuleRunListItemDto = {
    offset: number;
    limit: number;
    totalCount: number;
    items: null | Array<ModuleRunListItemDto>;
};

export type EntityListOfPathRunListItemDto = {
    offset: number;
    limit: number;
    totalCount: number;
    items: null | Array<PathRunListItemDto>;
};

export type EntityListOfPathTemplateListItemDto = {
    offset: number;
    limit: number;
    totalCount: number;
    items: null | Array<PathTemplateListItemDto>;
};

export type EntityListOfUserListItemDto = {
    offset: number;
    limit: number;
    totalCount: number;
    items: null | Array<UserListItemDto>;
};

export const ErrorCode = {
    Unspecified: 'Unspecified',
    OutOfRange: 'OutOfRange',
    NotFound: 'NotFound',
    Invalid: 'Invalid',
    Forbidden: 'Forbidden',
    TooManyRequests: 'TooManyRequests',
    Conflict: 'Conflict',
    NullOrEmpty: 'NullOrEmpty',
    Unauthorized: 'Unauthorized',
    ExternalProviderNotAvailable: 'ExternalProviderNotAvailable'
} as const;

export type ErrorCode = typeof ErrorCode[keyof typeof ErrorCode];

export type ErrorDetail = {
    code: ErrorCode;
    /**
     * Stable machine-readable subcode (free-form string for non-typed endpoints).
     * Clients branch / translate on this — never on string? ErrorDetail.Message.
     */
    reason?: null | string;
    /**
     * Optional human-readable message (validation hint, dev info). Not for client branching.
     */
    message?: null | string;
    /**
     * Placeholder values for translated messages, e.g. `{ "minLength": 8, "maxLength": 64 }`
     * for a `MinimumLengthValidator`. Frontend feeds these to its i18n interpolator
     * (e.g. `i18next.t(key, params)` with templates like `"…alespoň {{minLength}} znaků."`).
     */
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfAiCompletionErrorReason = {
    code: ErrorCode;
    reason?: null | AiCompletionErrorReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfAuthError = {
    code: ErrorCode;
    reason?: null | AuthError;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfCloseModuleRunReason = {
    code: ErrorCode;
    reason?: null | CloseModuleRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfClosePathRunReason = {
    code: ErrorCode;
    reason?: null | ClosePathRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfCreateCustomModuleReason = {
    code: ErrorCode;
    reason?: null | CreateCustomModuleReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfCreatePathTemplateReason = {
    code: ErrorCode;
    reason?: null | CreatePathTemplateReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfDeleteCustomModuleReason = {
    code: ErrorCode;
    reason?: null | DeleteCustomModuleReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfDeletePathTemplateReason = {
    code: ErrorCode;
    reason?: null | DeletePathTemplateReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfGetFileContentError = {
    code: ErrorCode;
    reason?: null | GetFileContentError;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfModuleRunOperationReason = {
    code: ErrorCode;
    reason?: null | ModuleRunOperationReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfPathStepOperationReason = {
    code: ErrorCode;
    reason?: null | PathStepOperationReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfReopenModuleRunReason = {
    code: ErrorCode;
    reason?: null | ReopenModuleRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfRevokeModuleRunShareReason = {
    code: ErrorCode;
    reason?: null | RevokeModuleRunShareReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfRevokePathRunShareReason = {
    code: ErrorCode;
    reason?: null | RevokePathRunShareReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfSabApiErrorReason = {
    code: ErrorCode;
    reason?: null | SabApiErrorReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfSendShareEmailReason = {
    code: ErrorCode;
    reason?: null | SendShareEmailReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfShareModuleRunReason = {
    code: ErrorCode;
    reason?: null | ShareModuleRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfSharePathRunReason = {
    code: ErrorCode;
    reason?: null | SharePathRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfStartModuleRunReason = {
    code: ErrorCode;
    reason?: null | StartModuleRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfStartPathRunReason = {
    code: ErrorCode;
    reason?: null | StartPathRunReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfUpdateCustomModuleReason = {
    code: ErrorCode;
    reason?: null | UpdateCustomModuleReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfUpdatePathTemplateReason = {
    code: ErrorCode;
    reason?: null | UpdatePathTemplateReason;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Phantom typed shape for OpenAPI/codegen — on the wire identical to ErrorDetail.
 * Used so that frontend codegen (NSwag → rest2ts) produces a typed `reason: TReason` field
 * for endpoints that constrain reasons to a specific enum (e.g. `AuthError`).
 */
export type ErrorDetailOfUploadFileError = {
    code: ErrorCode;
    reason?: null | UploadFileError;
    message?: null | string;
    params?: null | {
        [key: string]: unknown;
    };
};

/**
 * Identifies the upload site driving validation rules (allowed MIME, max size,
 * default cross-tenant visibility) via FileUploadContextConfig.
 * New consumers add a value here and register matching rules.
 */
export const FileUploadContext = { PathStepPdf: 'PathStepPdf' } as const;

/**
 * Identifies the upload site driving validation rules (allowed MIME, max size,
 * default cross-tenant visibility) via FileUploadContextConfig.
 * New consumers add a value here and register matching rules.
 */
export type FileUploadContext = typeof FileUploadContext[keyof typeof FileUploadContext];

/**
 *             Serializable form structure. Used as:
 * * Wire shape on the API (request body for create / update,
 * response body for detail GET) — OpenAPI describes the polymorphic
 * field union as oneOf with a discriminator, which
 * Hey API turns into a typed TS discriminated union.
 * * Persisted JSON blob in CustomModule.DefinitionJson
 * when the module is of kind Form.int FormDefinition.Version bumps on incompatible schema changes; the
 * validator rejects unknown versions.
 */
export type FormDefinition = {
    version: number;
    fields: Array<FormFieldDefinition>;
};

/**
 * Base for a single field in a FormDefinition. Discriminated
 * by the JSON property `kind`: `"system"` or `"custom"`.
 * string FormFieldDefinition.Id is client-generated (e.g. `crypto.randomUUID()`)
 * and stable across saves so future runtime can bind collected values to
 * specific fields regardless of reorder/insert/delete.
 */
export type FormFieldDefinition = ({
    kind?: 'system';
} & FormFieldDefinitionSystemFormFieldDefinition) | ({
    kind?: 'custom';
} & FormFieldDefinitionCustomFormFieldDefinition);

/**
 * Advisor-authored field instance. Label is user-entered; type is one of
 * the supported CustomFieldKind values.
 */
export type FormFieldDefinitionCustomFormFieldDefinition = {
    kind?: 'custom';
    fieldType: CustomFieldKind;
    label: string;
    id: string;
};

/**
 * Field whose semantics, label and data type are defined in code via
 * SystemFormKey + SystemFormKeyMetadataAttribute.
 * Only system keys decorated with `AllowedAsFormField = true` are
 * acceptable here.
 */
export type FormFieldDefinitionSystemFormFieldDefinition = {
    kind?: 'system';
    systemKey: SystemFormKey;
    id: string;
};

/**
 * Palette payload for the form builder's left column.
 * AddressValueDto? FormPaletteDto.AddressShape is always `null` at runtime — its sole
 * purpose is to anchor AddressValueDto (and transitively
 * AddressType) into the OpenAPI schema so the typed FE
 * client emits both.
 */
export type FormPaletteDto = {
    systemFields: Array<SystemFieldOptionDto>;
    customFieldTypes: Array<CustomFieldOptionDto>;
    addressShape: null | AddressValueDto;
};

/**
 * Stateless request body: the advisor's current draft plus the labeled snapshot of
 * the calculator(s). The backend never reads a persisted run — this works even for a
 * standalone calculator that has not been saved yet.
 */
export type GenerateClientSummaryRequest = {
    scope: ClientSummaryScope;
    draft: null | string;
    calculators: Array<ClientSummaryCalculator>;
};

/**
 * The AI suggestion plus the model that produced it (for telemetry).
 */
export type GenerateClientSummaryResult = {
    suggestion: string;
    model: string;
};

export const GetFileContentError = { FileNotFound: 'FileNotFound' } as const;

export type GetFileContentError = typeof GetFileContentError[keyof typeof GetFileContentError];

export type IFormFile = Blob | File;

/**
 * Primitive data type a system input or form field carries. Drives FE input
 * rendering and Zod schema generation.
 */
export const InputDataType = {
    Currency: 'Currency',
    Number: 'Number',
    Percent: 'Percent',
    Date: 'Date',
    Text: 'Text',
    Boolean: 'Boolean',
    Select: 'Select',
    MultiSelect: 'MultiSelect',
    Years: 'Years',
    Json: 'Json'
} as const;

/**
 * Primitive data type a system input or form field carries. Drives FE input
 * rendering and Zod schema generation.
 */
export type InputDataType = typeof InputDataType[keyof typeof InputDataType];

export type JsonElement = unknown;

/**
 * High-level grouping of modeling modules in the library, used for filtering
 * in the FE module catalog. Members are added as new modules join.
 */
export const ModelingCategory = {
    Housing: 'Housing',
    Pension: 'Pension',
    Protection: 'Protection',
    GoalsFinancing: 'GoalsFinancing',
    Underinsurance: 'Underinsurance',
    FinancialBalance: 'FinancialBalance'
} as const;

/**
 * High-level grouping of modeling modules in the library, used for filtering
 * in the FE module catalog. Members are added as new modules join.
 */
export type ModelingCategory = typeof ModelingCategory[keyof typeof ModelingCategory];

/**
 * One module entry in the catalog. `ComputeLocation` tells the FE
 * whether the module's calculation runs locally (Frontend) or via a
 * server-side recompute endpoint (Backend).
 */
export type ModuleCatalogEntryDto = {
    key: ModuleKey;
    category: ModelingCategory;
    computeLocation: ComputeLocation;
};

/**
 * Globally unique identifier of a modeling module (calculator). Code-first
 * catalog — every module is registered as an enum member here. Per-member
 * ModuleMetadataAttribute declares its category and whether
 * the calculation runs on the FE or BE.
 */
export const ModuleKey = {
    HousingRentVsMortgage: 'HousingRentVsMortgage',
    HousingMortgage: 'HousingMortgage',
    HousingOwnSources: 'HousingOwnSources',
    FinancialBalanceFinancialBalance: 'FinancialBalanceFinancialBalance',
    HousingRefinancing: 'HousingRefinancing',
    HousingExtraPayments: 'HousingExtraPayments',
    HousingRedeemMortgage: 'HousingRedeemMortgage',
    HousingHousingOverview: 'HousingHousingOverview',
    UnderinsuranceOverview: 'UnderinsuranceOverview',
    UnderinsurancePricesComparison: 'UnderinsurancePricesComparison',
    RentMyRent: 'RentMyRent',
    RentTargetSum: 'RentTargetSum',
    RentInvestmentAmount: 'RentInvestmentAmount',
    RentInvestmentPostpone: 'RentInvestmentPostpone',
    RentRentOverview: 'RentRentOverview',
    FinancialBalanceIncomes: 'FinancialBalanceIncomes',
    FinancialBalanceExpenses: 'FinancialBalanceExpenses',
    FinancialBalanceCompare: 'FinancialBalanceCompare',
    GoalsFinancingBankLoan: 'GoalsFinancingBankLoan',
    GoalsFinancingInvestmentSingle: 'GoalsFinancingInvestmentSingle',
    GoalsFinancingInvestmentRegular: 'GoalsFinancingInvestmentRegular',
    GoalsFinancingRent: 'GoalsFinancingRent',
    GoalsFinancingInvestmentByProducts: 'GoalsFinancingInvestmentByProducts',
    IncomeProtectionRiskOverview: 'IncomeProtectionRiskOverview',
    IncomeProtectionCausesOfDisability: 'IncomeProtectionCausesOfDisability',
    IncomeProtectionSecurityRequired: 'IncomeProtectionSecurityRequired',
    IncomeProtectionCurrentSecurity: 'IncomeProtectionCurrentSecurity',
    IncomeProtectionSecurityComparison: 'IncomeProtectionSecurityComparison',
    IncomeProtectionFirstInvalidity: 'IncomeProtectionFirstInvalidity',
    IncomeProtectionSecondInvalidity: 'IncomeProtectionSecondInvalidity',
    IncomeProtectionThirdInvalidity: 'IncomeProtectionThirdInvalidity',
    IncomeProtectionDailyLossOfIncome: 'IncomeProtectionDailyLossOfIncome',
    IncomeProtectionFinancialReserve: 'IncomeProtectionFinancialReserve',
    IncomeProtectionDeath: 'IncomeProtectionDeath'
} as const;

/**
 * Globally unique identifier of a modeling module (calculator). Code-first
 * catalog — every module is registered as an enum member here. Per-member
 * ModuleMetadataAttribute declares its category and whether
 * the calculation runs on the FE or BE.
 */
export type ModuleKey = typeof ModuleKey[keyof typeof ModuleKey];

export type ModuleRunDetailDto = {
    /**
     * ModuleRunID – protected ID as string
     */
    moduleRunID: string;
    moduleKey: ModuleKey;
    status: ModuleRunStatus;
    /**
     * ClientID – protected ID as string
     */
    clientID?: null | string;
    clientDisplayName?: null | string;
    clientBirthDate?: null | Date;
    inputsJson: string;
    outputsJson?: null | string;
    clientSummary?: null | string;
    computedAt?: null | Date;
    isPublic: boolean;
    publicShareToken?: null | string;
    dateCreated: Date;
    dateUpdated?: null | Date;
};

export type ModuleRunListItemDto = {
    /**
     * ModuleRunID – protected ID as string
     */
    moduleRunID: string;
    moduleKey: ModuleKey;
    status: ModuleRunStatus;
    /**
     * ClientID – protected ID as string
     */
    clientID?: null | string;
    clientDisplayName?: null | string;
    computedAt?: null | Date;
    dateCreated: Date;
    dateUpdated?: null | Date;
};

export const ModuleRunOperationReason = {
    RunNotFound: 'RunNotFound',
    RunIsClosed: 'RunIsClosed',
    ModuleKeyMismatch: 'ModuleKeyMismatch',
    InputsMissing: 'InputsMissing'
} as const;

export type ModuleRunOperationReason = typeof ModuleRunOperationReason[keyof typeof ModuleRunOperationReason];

export const ModuleRunStatus = {
    Draft: 'Draft',
    Computed: 'Computed',
    Closed: 'Closed'
} as const;

export type ModuleRunStatus = typeof ModuleRunStatus[keyof typeof ModuleRunStatus];

/**
 * Visibility / ownership level for advisor-authored artefacts (path templates,
 * custom forms). System = platform-seeded. Tenant = shared across one tenant
 * (firm). Personal = private to one advisor.
 */
export const OwnershipScope = {
    System: 'System',
    Tenant: 'Tenant',
    Personal: 'Personal'
} as const;

/**
 * Visibility / ownership level for advisor-authored artefacts (path templates,
 * custom forms). System = platform-seeded. Tenant = shared across one tenant
 * (firm). Personal = private to one advisor.
 */
export type OwnershipScope = typeof OwnershipScope[keyof typeof OwnershipScope];

export type PathRunDetailDto = {
    /**
     * PathRunID – protected ID as string
     */
    pathRunID: string;
    name: string;
    status: PathRunStatus;
    /**
     * ClientID – protected ID as string
     */
    clientID?: null | string;
    clientDisplayName?: null | string;
    clientBirthDate?: null | Date;
    clientSabClientID?: null | number;
    lineageID: string;
    versionNumber: number;
    lastEditedEpoch?: null | number;
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID?: null | string;
    sharedInputsJson: string;
    clientSummary?: null | string;
    steps: Array<PathRunStepDto>;
    isPublic: boolean;
    publicShareToken?: null | string;
    dateCreated: Date;
    dateUpdated?: null | Date;
};

export type PathRunListItemDto = {
    /**
     * PathRunID – protected ID as string
     */
    pathRunID: string;
    name: string;
    status: PathRunStatus;
    /**
     * ClientID – protected ID as string
     */
    clientID?: null | string;
    clientDisplayName?: null | string;
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID?: null | string;
    pathTemplateName?: null | string;
    stepCount: number;
    dateCreated: Date;
    dateUpdated?: null | Date;
};

export const PathRunStatus = {
    Draft: 'Draft',
    Ready: 'Ready',
    Presented: 'Presented',
    Closed: 'Closed'
} as const;

export type PathRunStatus = typeof PathRunStatus[keyof typeof PathRunStatus];

export type PathRunStepDto = {
    /**
     * PathRunStepID – protected ID as string
     */
    pathRunStepID: string;
    order: number;
    kind: PathStepKind;
    moduleKey?: null | ModuleKey;
    systemFormKey?: null | SystemFormKey;
    /**
     * CustomModuleID – protected ID as string
     */
    customModuleID?: null | string;
    customModuleName?: null | string;
    customModuleKind?: null | CustomModuleKind;
    filePublicToken?: null | string;
    fileOriginalFileName?: null | string;
    fileSizeBytes?: null | number;
    customName?: null | string;
    isHidden: boolean;
    isInternal: boolean;
    internalNote?: null | string;
    clientSummary?: null | string;
    inputsJson: string;
    outputsJson?: null | string;
    fieldBindingsJson: string;
    formDefinition?: null | FormDefinition;
    formResponseJson?: null | string;
    computedAt?: null | Date;
};

export type PathRunVersionListItemDto = {
    /**
     * PathRunID – protected ID as string
     */
    pathRunID: string;
    versionNumber: number;
    name: string;
    status: PathRunStatus;
    stepCount: number;
    dateCreated: Date;
    dateUpdated?: null | Date;
    isLatest: boolean;
};

/**
 * Kind of a step in a path (template recipe or run instance). Discriminates
 * which payload reference is populated on the step entity.
 */
export const PathStepKind = {
    ModelingModule: 'ModelingModule',
    SystemForm: 'SystemForm',
    CustomModule: 'CustomModule'
} as const;

/**
 * Kind of a step in a path (template recipe or run instance). Discriminates
 * which payload reference is populated on the step entity.
 */
export type PathStepKind = typeof PathStepKind[keyof typeof PathStepKind];

export const PathStepOperationReason = {
    RunNotFound: 'RunNotFound',
    StepNotFound: 'StepNotFound',
    RunIsClosed: 'RunIsClosed',
    StepIsNotModelingModule: 'StepIsNotModelingModule',
    ModuleKeyMismatch: 'ModuleKeyMismatch',
    InputsMissing: 'InputsMissing',
    UnknownSystemInputKey: 'UnknownSystemInputKey',
    BindingNotFound: 'BindingNotFound',
    StepIsNotForm: 'StepIsNotForm',
    FormResponseHasUnknownFields: 'FormResponseHasUnknownFields',
    FormResponseInvalid: 'FormResponseInvalid'
} as const;

export type PathStepOperationReason = typeof PathStepOperationReason[keyof typeof PathStepOperationReason];

export type PathTemplateDetailDto = {
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID: string;
    name: string;
    description?: null | string;
    scope: OwnershipScope;
    status: PathTemplateStatus;
    /**
     * UserID – protected ID as string
     */
    ownerUserID?: null | string;
    /**
     * TenantID – protected ID as string
     */
    ownerTenantID?: null | string;
    /**
     * UserID – protected ID as string
     */
    createdByUserID: string;
    steps: Array<PathTemplateStepDto>;
};

export type PathTemplateListItemDto = {
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID: string;
    name: string;
    description?: null | string;
    scope: OwnershipScope;
    status: PathTemplateStatus;
    stepCount: number;
    /**
     * UserID – protected ID as string
     */
    ownerUserID?: null | string;
    /**
     * TenantID – protected ID as string
     */
    ownerTenantID?: null | string;
    /**
     * UserID – protected ID as string
     */
    createdByUserID: string;
};

export type PathTemplateModuleMembershipDto = {
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID: string;
    name: string;
    scope: OwnershipScope;
    stepOrder: number;
    stepNumber: number;
    stepName?: null | string;
    stepCount: number;
};

export const PathTemplateStatus = { Active: 'Active', Archived: 'Archived' } as const;

export type PathTemplateStatus = typeof PathTemplateStatus[keyof typeof PathTemplateStatus];

export type PathTemplateStepDto = {
    /**
     * PathTemplateStepID – protected ID as string
     */
    pathTemplateStepID: string;
    order: number;
    kind: PathStepKind;
    moduleKey?: null | ModuleKey;
    systemFormKey?: null | SystemFormKey;
    /**
     * CustomModuleID – protected ID as string
     */
    customModuleID?: null | string;
    customModuleName?: null | string;
    customModuleKind?: null | CustomModuleKind;
    filePublicToken?: null | string;
    fileOriginalFileName?: null | string;
    fileSizeBytes?: null | number;
    customName?: null | string;
    isHidden: boolean;
    isInternal: boolean;
    isRequired: boolean;
    internalNote?: null | string;
};

/**
 * One step entry in a Create/Update path-template payload. PathTemplateStepID? PathTemplateStepInput.PathTemplateStepID
 * is null for new steps; populated when the FE sends back an existing step. The BE
 * owns ordering by re-stamping int PathTemplateStepInput.Order from the request payload — request
 * order wins.
 */
export type PathTemplateStepInput = {
    /**
     * PathTemplateStepID – protected ID as string
     */
    pathTemplateStepID: null | string;
    order: number;
    kind: PathStepKind;
    moduleKey: null | ModuleKey;
    systemFormKey: null | SystemFormKey;
    /**
     * CustomModuleID – protected ID as string
     */
    customModuleID: null | string;
    customName: null | string;
};

export type ProblemDetails = {
    type?: null | string;
    title?: null | string;
    status?: null | number;
    detail?: null | string;
    instance?: null | string;
};

export const ReopenModuleRunReason = { RunNotFound: 'RunNotFound', NotClosed: 'NotClosed' } as const;

export type ReopenModuleRunReason = typeof ReopenModuleRunReason[keyof typeof ReopenModuleRunReason];

export const RevokeModuleRunShareReason = { RunNotFound: 'RunNotFound' } as const;

export type RevokeModuleRunShareReason = typeof RevokeModuleRunShareReason[keyof typeof RevokeModuleRunShareReason];

export const RevokePathRunShareReason = { RunNotFound: 'RunNotFound' } as const;

export type RevokePathRunShareReason = typeof RevokePathRunShareReason[keyof typeof RevokePathRunShareReason];

export const SabAddressType = {
    Permanent: 'Permanent',
    Mailing: 'Mailing',
    Temporary: 'Temporary'
} as const;

export type SabAddressType = typeof SabAddressType[keyof typeof SabAddressType];

export type SabAgentOwnerDto = {
    registrationNumber: string;
    personId?: null | number;
};

export const SabApiErrorReason = {
    MissingAgentIdentification: 'MissingAgentIdentification',
    Unreachable: 'Unreachable',
    Timeout: 'Timeout',
    BadStatus: 'BadStatus',
    InvalidResponse: 'InvalidResponse'
} as const;

export type SabApiErrorReason = typeof SabApiErrorReason[keyof typeof SabApiErrorReason];

export type SabBankAccountDto = {
    number: string;
    iban: string;
    ownerName: string;
    currencyCode: SabCurrencyCode;
    bankCode: string;
    swift: string;
};

export const SabBusinessSector = {
    Administration: 'Administration',
    CarDealership: 'CarDealership',
    AutomotiveIndustry: 'AutomotiveIndustry',
    Banking: 'Banking',
    TourismAccommodation: 'TourismAccommodation',
    Nightclub: 'Nightclub',
    TransportLogistics: 'TransportLogistics',
    Economics: 'Economics',
    EnergyIndustry: 'EnergyIndustry',
    Pharmacy: 'Pharmacy',
    FinancialServices: 'FinancialServices',
    CateringHospitality: 'CateringHospitality',
    MetallurgicalIndustry: 'MetallurgicalIndustry',
    ChemicalIndustry: 'ChemicalIndustry',
    InformationTechnology: 'InformationTechnology',
    Casino: 'Casino',
    Cryptocurrencies: 'Cryptocurrencies',
    Culture: 'Culture',
    Forestry: 'Forestry',
    MarketingAdvertising: 'MarketingAdvertising',
    Purchasing: 'Purchasing',
    NonBankMoneyTransfers: 'NonBankMoneyTransfers',
    PreciousMetalsTrading: 'PreciousMetalsTrading',
    Defense: 'Defense',
    Security: 'Security',
    HumanResources: 'HumanResources',
    Insurance: 'Insurance',
    LoansWithoutCNBSupervision: 'LoansWithoutCNBSupervision',
    FoodIndustry: 'FoodIndustry',
    LegalServices: 'LegalServices',
    SalesTrading: 'SalesTrading',
    RealEstateRenting: 'RealEstateRenting',
    RealEstateServices: 'RealEstateServices',
    Crafts: 'Crafts',
    RecyclingCenter: 'RecyclingCenter',
    Services: 'Services',
    CurrencyExchange: 'CurrencyExchange',
    SocialServices: 'SocialServices',
    PropertyManagement: 'PropertyManagement',
    Construction: 'Construction',
    MechanicalEngineering: 'MechanicalEngineering',
    Education: 'Education',
    TechnologyDevelopment: 'TechnologyDevelopment',
    Telecommunications: 'Telecommunications',
    TextileIndustry: 'TextileIndustry',
    MiningIndustry: 'MiningIndustry',
    PublicProcurement: 'PublicProcurement',
    ScienceResearch: 'ScienceResearch',
    PublicAdministration: 'PublicAdministration',
    Manufacturing: 'Manufacturing',
    ForeignTrade: 'ForeignTrade',
    Pawnshop: 'Pawnshop',
    ArmsIndustry: 'ArmsIndustry',
    Healthcare: 'Healthcare',
    Agriculture: 'Agriculture',
    Pension: 'Pension',
    WaterManagement: 'WaterManagement',
    ProfessionalAthleteOrArtist: 'ProfessionalAthleteOrArtist'
} as const;

export type SabBusinessSector = typeof SabBusinessSector[keyof typeof SabBusinessSector];

export type SabClientAddressDto = {
    type: SabAddressType;
    countryCode?: null | string;
    street?: null | string;
    city?: null | string;
    zipCode?: null | string;
    descriptionNumber?: null | string;
    orientationNumber?: null | string;
};

export type SabClientAssignmentDto = {
    type: SabClientAssignmentType;
    assigned?: null | SabClientDetailDto;
};

export const SabClientAssignmentType = {
    Representative: 'Representative',
    Disponent: 'Disponent',
    Owner: 'Owner'
} as const;

export type SabClientAssignmentType = typeof SabClientAssignmentType[keyof typeof SabClientAssignmentType];

export type SabClientCountryDto = {
    countryCode?: null | string;
    clientCountryType: SabClientCountryType;
};

export const SabClientCountryType = {
    Nationality: 'Nationality',
    PermanentResidency: 'PermanentResidency',
    TaxResidency: 'TaxResidency',
    OverOneYearResidency: 'OverOneYearResidency',
    OverThreeMonthsResidency: 'OverThreeMonthsResidency',
    CompanyCountry: 'CompanyCountry',
    CompanyBranch: 'CompanyBranch',
    VatIdentificationIssued: 'VatIdentificationIssued'
} as const;

export type SabClientCountryType = typeof SabClientCountryType[keyof typeof SabClientCountryType];

export type SabClientDetailDto = {
    type: SabClientType;
    representativeType?: null | SabRepresentativeType;
    gender?: null | SabGender;
    titleBefore?: null | string;
    titleAfter?: null | string;
    firstName?: null | string;
    lastName?: null | string;
    companyName?: null | string;
    personalIdentificationNumber?: null | string;
    identificationNumber?: null | string;
    vatIdentificationNumber?: null | string;
    email: string;
    phonePrefix?: null | string;
    phone?: null | string;
    mobilePhonePrefix?: null | string;
    mobilePhone?: null | string;
    amlIdentified?: null | boolean;
    consentsResolved?: null | boolean;
    hasMarketingConsent?: null | boolean;
    gdprConsent?: null | boolean;
    responsiblePersonFirstName?: null | string;
    responsiblePersonLastName?: null | string;
    identityCard?: null | SabIdentityCardDto;
    clientInfo?: null | SabClientInfoDto;
    addresses: Array<SabClientAddressDto>;
    bankAccounts: Array<SabBankAccountDto>;
    clientAssignments: Array<SabClientAssignmentDto>;
};

export type SabClientIncomeDto = {
    incomeType: SabIncomeType;
    specification?: null | string;
};

export type SabClientInfoDto = {
    birthDate?: null | Date;
    birthPlace?: null | string;
    birthCountry?: null | string;
    isPoliticallyPerson?: null | boolean;
    pepAdditionalInfo?: null | string;
    isEntrepreneur: boolean;
    lei?: null | string;
    companyName?: null | string;
    position?: null | string;
    employmentType?: null | SabEmploymentType;
    legalForm?: null | SabLegalForm;
    companyRegistrationDate?: null | Date;
    yearlyIncomeInThousands?: null | number;
    livingAbroadMoreThanYear?: null | boolean;
    isOfficeAddress?: null | boolean;
    isOwnerBusinessRisky?: null | boolean;
    isAnyCompanyPersonFromRiskCountry?: null | boolean;
    signatoryAction?: null | SabSignatoryAction;
    sanctionedByCR?: null | boolean;
    businessSector?: null | SabBusinessSector;
    propertyVolume?: null | number;
    investmentPurposeType?: null | SabInvestmentPurposeType;
    investmentPurposeTypeAdditional?: null | string;
    specificSymbol?: null | string;
    moneySourceOrigin?: null | string;
    moneySourceAdditionalInfo?: null | string;
    ownerType?: null | string;
    ownershipAndManagementInfo?: null | string;
    clientStatement?: null | SabClientStatementDto;
    clientCountries: Array<SabClientCountryDto>;
    clientIncomes: Array<SabClientIncomeDto>;
    clientMoneySources: Array<SabClientMoneySourceDto>;
};

export type SabClientListItemDto = {
    sabClientID: number;
    type: SabClientType;
    titleBefore?: null | string;
    titleAfter?: null | string;
    firstName?: null | string;
    lastName?: null | string;
    personalIdentificationNumber?: null | string;
    companyName?: null | string;
    companyIdentificationNumber?: null | string;
    agentOwner?: null | SabAgentOwnerDto;
};

export type SabClientMoneySourceDto = {
    type: SabMoneySourceType;
    additionalText?: null | string;
};

export type SabClientStatementDto = {
    marketingAgreement?: null | boolean;
    personalDataTransfer?: null | boolean;
    remoteAccessInfo?: null | boolean;
    emailCommunication?: null | boolean;
    confirmationStatements?: null | boolean;
    investorInfo?: null | boolean;
    regularCircumstancesContract?: null | boolean;
    identificationAndVerificationConfirmed?: null | boolean;
};

export const SabClientType = { PhysicalPerson: 'PhysicalPerson', Company: 'Company' } as const;

export type SabClientType = typeof SabClientType[keyof typeof SabClientType];

export const SabCurrencyCode = {
    CZK: 'CZK',
    EUR: 'EUR',
    USD: 'USD',
    GBP: 'GBP',
    JPY: 'JPY',
    AUD: 'AUD',
    SGD: 'SGD',
    CHF: 'CHF',
    HUF: 'HUF',
    PLN: 'PLN',
    NOK: 'NOK',
    RON: 'RON',
    HKD: 'HKD',
    DKK: 'DKK',
    CAD: 'CAD',
    CNY: 'CNY',
    NZD: 'NZD',
    SEK: 'SEK',
    TRY: 'TRY',
    UNKNOWN: 'UNKNOWN'
} as const;

export type SabCurrencyCode = typeof SabCurrencyCode[keyof typeof SabCurrencyCode];

export const SabEmploymentType = { Leading: 'Leading', NonLeading: 'NonLeading' } as const;

export type SabEmploymentType = typeof SabEmploymentType[keyof typeof SabEmploymentType];

export const SabGender = {
    Unspecified: 'Unspecified',
    Male: 'Male',
    Female: 'Female'
} as const;

export type SabGender = typeof SabGender[keyof typeof SabGender];

export type SabIdentityCardDto = {
    number: string;
    validFrom?: null | Date;
    validTo?: null | Date;
    type?: null | SabIdentityCardType;
    issued?: null | string;
    issuedCountry?: null | string;
    isVerifiedExternally: boolean;
};

export const SabIdentityCardType = {
    Unknown: 'Unknown',
    IdentityCard: 'IdentityCard',
    Passport: 'Passport',
    BirthList: 'BirthList',
    DriversLicense: 'DriversLicense',
    PermanentResidencePermit: 'PermanentResidencePermit'
} as const;

export type SabIdentityCardType = typeof SabIdentityCardType[keyof typeof SabIdentityCardType];

export const SabIncomeType = {
    Employment: 'Employment',
    SelfEmployment: 'SelfEmployment',
    RentalIncome: 'RentalIncome',
    CapitalIncome: 'CapitalIncome',
    PensionIncome: 'PensionIncome',
    Other: 'Other'
} as const;

export type SabIncomeType = typeof SabIncomeType[keyof typeof SabIncomeType];

export const SabInvestmentPurposeType = { Accumulation: 'Accumulation', Other: 'Other' } as const;

export type SabInvestmentPurposeType = typeof SabInvestmentPurposeType[keyof typeof SabInvestmentPurposeType];

export const SabLegalForm = {
    Entrepreneur: 'Entrepreneur',
    LimitedLiabilityCompany: 'LimitedLiabilityCompany',
    JointStockCompany: 'JointStockCompany',
    GeneralPartnership: 'GeneralPartnership',
    LimitedPartnership: 'LimitedPartnership',
    Cooperative: 'Cooperative',
    EuropeanCompany: 'EuropeanCompany',
    EuropeanEconomicInterestGrouping: 'EuropeanEconomicInterestGrouping',
    Other: 'Other'
} as const;

export type SabLegalForm = typeof SabLegalForm[keyof typeof SabLegalForm];

export const SabMoneySourceType = {
    EmploymentIncome: 'EmploymentIncome',
    BusinessIncome: 'BusinessIncome',
    Savings: 'Savings',
    Heritage: 'Heritage',
    RentalIncome: 'RentalIncome',
    PropertySale: 'PropertySale',
    Donation: 'Donation',
    Pension: 'Pension',
    CompanySale: 'CompanySale',
    IncomeSavings: 'IncomeSavings',
    AssetSale: 'AssetSale',
    SecuritiesSale: 'SecuritiesSale',
    ReceivableSale: 'ReceivableSale',
    DividendsPayout: 'DividendsPayout',
    ContestWin: 'ContestWin',
    Other: 'Other'
} as const;

export type SabMoneySourceType = typeof SabMoneySourceType[keyof typeof SabMoneySourceType];

export const SabRepresentativeType = {
    PowerOfAttorney: 'PowerOfAttorney',
    LegalRepresentative: 'LegalRepresentative',
    Guardian: 'Guardian'
} as const;

export type SabRepresentativeType = typeof SabRepresentativeType[keyof typeof SabRepresentativeType];

export const SabSignatoryAction = { Independent: 'Independent', Common: 'Common' } as const;

export type SabSignatoryAction = typeof SabSignatoryAction[keyof typeof SabSignatoryAction];

export type SearchSabClientsResponse = {
    clients: Array<SabClientListItemDto>;
    offset: number;
    limit: number;
    hasMore: boolean;
};

export const SendShareEmailReason = {
    RunNotFound: 'RunNotFound',
    NotShared: 'NotShared',
    ClientEmailMissing: 'ClientEmailMissing'
} as const;

export type SendShareEmailReason = typeof SendShareEmailReason[keyof typeof SendShareEmailReason];

/**
 * Request body for setting a standalone modelation's client summary.
 */
export type SetModuleRunClientSummaryRequest = {
    clientSummary: null | string;
};

/**
 * Request body for setting a path run's overall client summary.
 */
export type SetPathRunClientSummaryRequest = {
    clientSummary: null | string;
};

/**
 * Request body for setting a single path step's client summary.
 */
export type SetPathStepClientSummaryRequest = {
    clientSummary: null | string;
};

export type SetPathStepFormResponseCommandRequest = {
    response: JsonElement;
    currentClientEpoch: null | number;
};

export type SetPathStepFormResponseResult = {
    /**
     * PathRunID – protected ID as string
     */
    effectivePathRunID: string;
    /**
     * PathRunStepID – protected ID as string
     */
    effectiveStepID: string;
    forked: boolean;
    versionNumber: number;
};

/**
 * Body for SetPathStepInputsCommand. `Promote` carries
 * system-input values that the FE wants merged into the path-run shared inputs
 * bag (string PathRun.SharedInputsJson) alongside the per-step write —
 * i.e. fields tagged on the FE as canonical system inputs and not opted out of
 * sharing on this step. A `null` value clears the key from the bag. Pass
 * an empty / null map when the step has no shared fields.
 * JsonElement? SetPathStepInputsCommandRequest.Outputs optionally carries the FE-computed outputs for the same
 * step so inputs + outputs persist in a single transaction (the FE computes
 * locally, so the two always travel together). When `null` the cached
 * outputs stay invalidated — the inputs write already nulls them.
 * int? SetPathStepInputsCommandRequest.CurrentClientEpoch is the FE's per-client epoch counter; on
 * mismatch with the target row's `LastEditedEpoch` the handler forks a
 * new version of the lineage before applying the mutation.
 */
export type SetPathStepInputsCommandRequest = {
    inputs: JsonElement;
    promote: null | {
        [key: string]: unknown;
    };
    currentClientEpoch: null | number;
    outputs?: unknown;
};

export type SetPathStepInputsResult = {
    /**
     * PathRunID – protected ID as string
     */
    effectivePathRunID: string;
    /**
     * PathRunStepID – protected ID as string
     */
    effectiveStepID: string;
    forked: boolean;
    versionNumber: number;
};

export type SetPathStepOutputsCommandRequest = {
    outputs: JsonElement;
    currentClientEpoch: null | number;
};

export type SetPathStepOutputsResult = {
    /**
     * PathRunID – protected ID as string
     */
    effectivePathRunID: string;
    /**
     * PathRunStepID – protected ID as string
     */
    effectiveStepID: string;
    forked: boolean;
    versionNumber: number;
};

export type SharedModuleRunDto = {
    moduleKey: ModuleKey;
    inputsJson: string;
    outputsJson?: null | string;
    clientSummary?: null | string;
    advisorName: string;
    tenantName: string;
    branding?: null | SharedRunBrandingDto;
};

export type SharedPathRunDto = {
    name: string;
    sharedInputsJson: string;
    clientSummary?: null | string;
    steps: Array<PathRunStepDto>;
    advisorName: string;
    tenantName: string;
    branding?: null | SharedRunBrandingDto;
};

export type SharedRunBrandingDto = {
    logoUrl?: null | string;
    primaryColor?: null | string;
};

export const ShareModuleRunReason = { RunNotFound: 'RunNotFound', ClientRequired: 'ClientRequired' } as const;

export type ShareModuleRunReason = typeof ShareModuleRunReason[keyof typeof ShareModuleRunReason];

export type ShareModuleRunResult = {
    publicShareToken: string;
};

export const SharePathRunReason = { RunNotFound: 'RunNotFound', ClientRequired: 'ClientRequired' } as const;

export type SharePathRunReason = typeof SharePathRunReason[keyof typeof SharePathRunReason];

export type SharePathRunResult = {
    publicShareToken: string;
};

export type SignInCommandRequest = {
    login: string;
    password: string;
};

export type SignInResult = {
    userInfo: UserInfo;
    isFirstSignIn: boolean;
};

export type StartModuleRunCommandRequest = {
    moduleKey: ModuleKey;
    /**
     * ClientID – protected ID as string
     */
    clientID: null | string;
    sabClientID: null | number;
    sabIdentificationNumber: null | string;
};

export const StartModuleRunReason = {
    ClientNotFound: 'ClientNotFound',
    ClientAndSabClientMutuallyExclusive: 'ClientAndSabClientMutuallyExclusive',
    MissingSabIdentificationNumber: 'MissingSabIdentificationNumber'
} as const;

export type StartModuleRunReason = typeof StartModuleRunReason[keyof typeof StartModuleRunReason];

export type StartModuleRunResult = {
    /**
     * ModuleRunID – protected ID as string
     */
    moduleRunID: string;
};

export type StartPathRunCommandRequest = {
    name: string;
    /**
     * PathTemplateID – protected ID as string
     */
    pathTemplateID: null | string;
    /**
     * ClientID – protected ID as string
     */
    clientID: null | string;
    sabClientID: null | number;
    sabIdentificationNumber: null | string;
    forceNewLineage: boolean;
    seedModuleKey?: null | ModuleKey;
    seedStepOrder?: null | number;
    seedInputsJson?: null | string;
};

export const StartPathRunReason = {
    TemplateNotFound: 'TemplateNotFound',
    ClientNotFound: 'ClientNotFound',
    ClientAndSabClientMutuallyExclusive: 'ClientAndSabClientMutuallyExclusive',
    MissingSabIdentificationNumber: 'MissingSabIdentificationNumber',
    SeedRequiresTemplate: 'SeedRequiresTemplate',
    SeedStepNotFound: 'SeedStepNotFound',
    InvalidSeedInputsJson: 'InvalidSeedInputsJson'
} as const;

export type StartPathRunReason = typeof StartPathRunReason[keyof typeof StartPathRunReason];

export type StartPathRunResult = {
    /**
     * PathRunID – protected ID as string
     */
    pathRunID: string;
    lineageID: string;
    versionNumber: number;
    /**
     * PathRunStepID – protected ID as string
     */
    seededStepID: null | string;
};

/**
 * One system field option exposed to the form-builder palette
 * ("Systémové prvky"). Filtered to SystemFormKey members
 * decorated with `AllowedAsFormField = true`.
 */
export type SystemFieldOptionDto = {
    key: SystemFormKey;
    dataType: SystemFormDataType;
    allowMultipleInstances: boolean;
};

/**
 * High-level data shape of a SystemFormKey. Drives FE input
 * rendering once the form runtime ships; today only used as informational
 * metadata in the builder palette.
 */
export const SystemFormDataType = {
    Composite: 'Composite',
    Numeric: 'Numeric',
    Text: 'Text',
    Date: 'Date',
    Money: 'Money',
    Percent: 'Percent',
    Address: 'Address',
    Email: 'Email',
    Phone: 'Phone'
} as const;

/**
 * High-level data shape of a SystemFormKey. Drives FE input
 * rendering once the form runtime ships; today only used as informational
 * metadata in the builder palette.
 */
export type SystemFormDataType = typeof SystemFormDataType[keyof typeof SystemFormDataType];

export const SystemFormKey = {
    ClientIdentity: 'ClientIdentity',
    ClientGoals: 'ClientGoals',
    MeetingNote: 'MeetingNote',
    MonthlyIncome: 'MonthlyIncome',
    MonthlyExpenses: 'MonthlyExpenses',
    ClientFirstName: 'ClientFirstName',
    ClientLastName: 'ClientLastName',
    ClientJob: 'ClientJob',
    ClientAge: 'ClientAge',
    ClientBirthDate: 'ClientBirthDate',
    ClientBirthPlace: 'ClientBirthPlace',
    ClientAddress: 'ClientAddress',
    ClientEmail: 'ClientEmail',
    ClientPhone: 'ClientPhone'
} as const;

export type SystemFormKey = typeof SystemFormKey[keyof typeof SystemFormKey];

export type SystemInputDefinitionDto = {
    key: SystemInputKey;
    dataType: InputDataType;
    group: SystemInputGroup;
    resourceKey: string;
    defaultUnit: null | string;
};

export const SystemInputGroup = {
    HouseholdFinances: 'HouseholdFinances',
    Property: 'Property',
    Family: 'Family',
    Insurance: 'Insurance',
    Investments: 'Investments',
    Retirement: 'Retirement',
    HouseholdBudget: 'HouseholdBudget'
} as const;

export type SystemInputGroup = typeof SystemInputGroup[keyof typeof SystemInputGroup];

/**
 * Canonical vocabulary of shared inputs across modeling modules. Code-first
 * catalog (no DB table). Modules and custom forms reference these as enums,
 * never magic strings. Persisted in DB as enum-name strings via
 * `ConfigureEnumProperty`.
 */
export const SystemInputKey = {
    HouseholdMonthlyNetIncome: 'HouseholdMonthlyNetIncome',
    HouseholdMonthlyExpenses: 'HouseholdMonthlyExpenses',
    MonthlyRent: 'MonthlyRent',
    NumberOfChildren: 'NumberOfChildren',
    NumberOfDependents: 'NumberOfDependents',
    LiquidReserve: 'LiquidReserve',
    PropertyValue: 'PropertyValue',
    OwnFunds: 'OwnFunds',
    ExistingMortgageBalance: 'ExistingMortgageBalance',
    ExistingMortgageMonthlyPayment: 'ExistingMortgageMonthlyPayment',
    ExistingMortgageRatePct: 'ExistingMortgageRatePct',
    PartnerMonthlyNetIncome: 'PartnerMonthlyNetIncome',
    IncomeStability: 'IncomeStability',
    ClientAge: 'ClientAge',
    RetirementAge: 'RetirementAge',
    InflationRatePct: 'InflationRatePct',
    MoneyAppreciationPct: 'MoneyAppreciationPct',
    GrossMonthlyIncome: 'GrossMonthlyIncome',
    AverageAnnualTaxBase: 'AverageAnnualTaxBase',
    PensionDecreasedIncome: 'PensionDecreasedIncome',
    PensionRequiredSum: 'PensionRequiredSum',
    CustomPensionAmount: 'CustomPensionAmount',
    FinancialBalanceIncomes: 'FinancialBalanceIncomes',
    FinancialBalanceExpenses: 'FinancialBalanceExpenses',
    FinancialBalanceEvents: 'FinancialBalanceEvents',
    IncomeProtectionCurrentInsurance: 'IncomeProtectionCurrentInsurance',
    IncomeProtectionProposedInsurance: 'IncomeProtectionProposedInsurance',
    HasPartner: 'HasPartner',
    IncomeProtectionPersonDetails: 'IncomeProtectionPersonDetails'
} as const;

/**
 * Canonical vocabulary of shared inputs across modeling modules. Code-first
 * catalog (no DB table). Modules and custom forms reference these as enums,
 * never magic strings. Persisted in DB as enum-name strings via
 * `ConfigureEnumProperty`.
 */
export type SystemInputKey = typeof SystemInputKey[keyof typeof SystemInputKey];

export type ToggleFieldBindingModeCommandRequest = {
    fieldKey: string;
    mode: BindingMode;
    systemInputKey: null | SystemInputKey;
    localValue: null | number;
    currentClientEpoch: null | number;
};

export type ToggleFieldBindingModeResult = {
    /**
     * PathRunID – protected ID as string
     */
    effectivePathRunID: string;
    /**
     * PathRunStepID – protected ID as string
     */
    effectiveStepID: string;
    forked: boolean;
    versionNumber: number;
};

export type UpdateCustomModuleCommandRequest = {
    name: string;
    description: null | string;
    /**
     * FileID – protected ID as string
     */
    fileID: null | string;
    scope: OwnershipScope;
    definition: null | FormDefinition;
};

export const UpdateCustomModuleReason = {
    NotAuthenticated: 'NotAuthenticated',
    ModuleNotFound: 'ModuleNotFound',
    NotOwner: 'NotOwner',
    InvalidScope: 'InvalidScope',
    MissingFileForPdfKind: 'MissingFileForPdfKind',
    FileNotFound: 'FileNotFound',
    MissingDefinitionForFormKind: 'MissingDefinitionForFormKind',
    InvalidDefinition: 'InvalidDefinition',
    FormHasNoFields: 'FormHasNoFields',
    FileMustBeNullForFormKind: 'FileMustBeNullForFormKind',
    DefinitionMustBeNullForPdfKind: 'DefinitionMustBeNullForPdfKind'
} as const;

export type UpdateCustomModuleReason = typeof UpdateCustomModuleReason[keyof typeof UpdateCustomModuleReason];

export type UpdatePathTemplateCommandRequest = {
    name: string;
    description: null | string;
    scope: OwnershipScope;
    steps: Array<PathTemplateStepInput>;
};

export const UpdatePathTemplateReason = {
    TemplateNotFound: 'TemplateNotFound',
    NotOwner: 'NotOwner',
    StepKindNotSupportedYet: 'StepKindNotSupportedYet',
    NotAuthenticated: 'NotAuthenticated',
    InvalidScope: 'InvalidScope'
} as const;

export type UpdatePathTemplateReason = typeof UpdatePathTemplateReason[keyof typeof UpdatePathTemplateReason];

export const UploadFileError = {
    EmptyFile: 'EmptyFile',
    MimeTypeNotAllowed: 'MimeTypeNotAllowed',
    FileTooLarge: 'FileTooLarge'
} as const;

export type UploadFileError = typeof UploadFileError[keyof typeof UploadFileError];

export type UploadFileResult = {
    /**
     * FileID – protected ID as string
     */
    fileID: string;
    publicToken: string;
};

export type UserDetailDto = {
    /**
     * UserID – protected ID as string
     */
    userID: string;
    login: string;
    email: string;
    firstName?: null | string;
    lastName?: null | string;
    lastSignInDate?: null | Date;
    phone?: null | string;
    profilePicture?: null | string;
    status: UserStatus;
};

export type UserInfo = {
    token: string;
    /**
     * UserID – protected ID as string
     */
    userID: string;
    login: string;
    firstName: string;
    lastName: string;
    accessRightCodes: Array<AccessRightCode>;
    accessRoleCodes: Array<AccessRoleCode>;
    profilePicture: null | string;
    myDockUrl: null | string;
    branding: null | UserInfoBranding;
};

/**
 * Tenant visual identity delivered with userinfo so the FE can re-skin the
 * app (primary color, logos) per tenant. Null when the tenant has no branding row.
 */
export type UserInfoBranding = {
    primaryColor: null | string;
    logoUrl: null | string;
};

export type UserListItemDto = {
    /**
     * UserID – protected ID as string
     */
    userID: string;
    login: string;
    firstName: string;
    lastName: string;
    dateCreated: Date;
};

export const UserStatus = {
    Unknown: 'Unknown',
    Active: 'Active',
    WaitingForEmailConfirmation: 'WaitingForEmailConfirmation'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];

export type GetApiV1UsersData = {
    body?: never;
    path?: never;
    query?: {
        Offset?: number;
        Limit?: number;
    };
    url: '/api/v1/users';
};

export type GetApiV1UsersErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1UsersError = GetApiV1UsersErrors[keyof GetApiV1UsersErrors];

export type GetApiV1UsersResponses = {
    /**
     * OK
     */
    200: EntityListOfUserListItemDto;
};

export type GetApiV1UsersResponse = GetApiV1UsersResponses[keyof GetApiV1UsersResponses];

export type GetApiV1UsersByUserIdData = {
    body?: never;
    path: {
        userId: string;
    };
    query?: never;
    url: '/api/v1/users/{userId}';
};

export type GetApiV1UsersByUserIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1UsersByUserIdError = GetApiV1UsersByUserIdErrors[keyof GetApiV1UsersByUserIdErrors];

export type GetApiV1UsersByUserIdResponses = {
    /**
     * OK
     */
    200: UserDetailDto;
};

export type GetApiV1UsersByUserIdResponse = GetApiV1UsersByUserIdResponses[keyof GetApiV1UsersByUserIdResponses];

export type GetApiV1PdfSampleData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pdf/sample';
};

export type GetApiV1PdfSampleErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PdfSampleError = GetApiV1PdfSampleErrors[keyof GetApiV1PdfSampleErrors];

export type GetApiV1PdfSampleResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type GetApiV1PdfSampleResponse = GetApiV1PdfSampleResponses[keyof GetApiV1PdfSampleResponses];

export type GetApiV1PdfModuleSampleData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/pdf/module-sample';
};

export type GetApiV1PdfModuleSampleErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PdfModuleSampleError = GetApiV1PdfModuleSampleErrors[keyof GetApiV1PdfModuleSampleErrors];

export type GetApiV1PdfModuleSampleResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type GetApiV1PdfModuleSampleResponse = GetApiV1PdfModuleSampleResponses[keyof GetApiV1PdfModuleSampleResponses];

export type PostApiV1PdfModuleByModuleKeyData = {
    body: JsonElement;
    path: {
        moduleKey: ModuleKey;
    };
    query?: never;
    url: '/api/v1/pdf/module/{moduleKey}';
};

export type PostApiV1PdfModuleByModuleKeyErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetails;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PdfModuleByModuleKeyError = PostApiV1PdfModuleByModuleKeyErrors[keyof PostApiV1PdfModuleByModuleKeyErrors];

export type PostApiV1PdfModuleByModuleKeyResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type PostApiV1PdfModuleByModuleKeyResponse = PostApiV1PdfModuleByModuleKeyResponses[keyof PostApiV1PdfModuleByModuleKeyResponses];

export type PostApiV1PdfPathByPathRunIdData = {
    body: Array<string>;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/pdf/path/{pathRunId}';
};

export type PostApiV1PdfPathByPathRunIdErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetails;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1PdfPathByPathRunIdError = PostApiV1PdfPathByPathRunIdErrors[keyof PostApiV1PdfPathByPathRunIdErrors];

export type PostApiV1PdfPathByPathRunIdResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type PostApiV1PdfPathByPathRunIdResponse = PostApiV1PdfPathByPathRunIdResponses[keyof PostApiV1PdfPathByPathRunIdResponses];

export type GetApiV1PdfPathRenderData = {
    body?: never;
    path?: never;
    query?: {
        token?: string;
    };
    url: '/api/v1/pdf/path-render';
};

export type GetApiV1PdfPathRenderErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1PdfPathRenderError = GetApiV1PdfPathRenderErrors[keyof GetApiV1PdfPathRenderErrors];

export type GetApiV1PdfPathRenderResponses = {
    /**
     * OK
     */
    200: SharedPathRunDto;
};

export type GetApiV1PdfPathRenderResponse = GetApiV1PdfPathRenderResponses[keyof GetApiV1PdfPathRenderResponses];

export type GetApiV1ModelingSystemInputsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/system-inputs';
};

export type GetApiV1ModelingSystemInputsErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingSystemInputsError = GetApiV1ModelingSystemInputsErrors[keyof GetApiV1ModelingSystemInputsErrors];

export type GetApiV1ModelingSystemInputsResponses = {
    /**
     * OK
     */
    200: Array<SystemInputDefinitionDto>;
};

export type GetApiV1ModelingSystemInputsResponse = GetApiV1ModelingSystemInputsResponses[keyof GetApiV1ModelingSystemInputsResponses];

export type GetApiV1ModelingPathTemplatesData = {
    body?: never;
    path?: never;
    query?: {
        Offset?: number;
        Limit?: number;
        Scope?: OwnershipScope;
        Status?: PathTemplateStatus;
        Search?: string;
    };
    url: '/api/v1/modeling/path-templates';
};

export type GetApiV1ModelingPathTemplatesErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathTemplatesError = GetApiV1ModelingPathTemplatesErrors[keyof GetApiV1ModelingPathTemplatesErrors];

export type GetApiV1ModelingPathTemplatesResponses = {
    /**
     * OK
     */
    200: EntityListOfPathTemplateListItemDto;
};

export type GetApiV1ModelingPathTemplatesResponse = GetApiV1ModelingPathTemplatesResponses[keyof GetApiV1ModelingPathTemplatesResponses];

export type PostApiV1ModelingPathTemplatesData = {
    body: CreatePathTemplateCommandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/path-templates';
};

export type PostApiV1ModelingPathTemplatesErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfCreatePathTemplateReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfCreatePathTemplateReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathTemplatesError = PostApiV1ModelingPathTemplatesErrors[keyof PostApiV1ModelingPathTemplatesErrors];

export type PostApiV1ModelingPathTemplatesResponses = {
    /**
     * OK
     */
    200: CreatePathTemplateResult;
};

export type PostApiV1ModelingPathTemplatesResponse = PostApiV1ModelingPathTemplatesResponses[keyof PostApiV1ModelingPathTemplatesResponses];

export type DeleteApiV1ModelingPathTemplatesByPathTemplateIdData = {
    body?: never;
    path: {
        pathTemplateId: string;
    };
    query?: never;
    url: '/api/v1/modeling/path-templates/{pathTemplateId}';
};

export type DeleteApiV1ModelingPathTemplatesByPathTemplateIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfDeletePathTemplateReason;
    /**
     * Forbidden
     */
    403: ApiProblemDetailsOfDeletePathTemplateReason;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfDeletePathTemplateReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ModelingPathTemplatesByPathTemplateIdError = DeleteApiV1ModelingPathTemplatesByPathTemplateIdErrors[keyof DeleteApiV1ModelingPathTemplatesByPathTemplateIdErrors];

export type DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponse = DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponses[keyof DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponses];

export type GetApiV1ModelingPathTemplatesByPathTemplateIdData = {
    body?: never;
    path: {
        pathTemplateId: string;
    };
    query?: never;
    url: '/api/v1/modeling/path-templates/{pathTemplateId}';
};

export type GetApiV1ModelingPathTemplatesByPathTemplateIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathTemplatesByPathTemplateIdError = GetApiV1ModelingPathTemplatesByPathTemplateIdErrors[keyof GetApiV1ModelingPathTemplatesByPathTemplateIdErrors];

export type GetApiV1ModelingPathTemplatesByPathTemplateIdResponses = {
    /**
     * OK
     */
    200: PathTemplateDetailDto;
};

export type GetApiV1ModelingPathTemplatesByPathTemplateIdResponse = GetApiV1ModelingPathTemplatesByPathTemplateIdResponses[keyof GetApiV1ModelingPathTemplatesByPathTemplateIdResponses];

export type PutApiV1ModelingPathTemplatesByPathTemplateIdData = {
    body: UpdatePathTemplateCommandRequest;
    path: {
        pathTemplateId: string;
    };
    query?: never;
    url: '/api/v1/modeling/path-templates/{pathTemplateId}';
};

export type PutApiV1ModelingPathTemplatesByPathTemplateIdErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfUpdatePathTemplateReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfUpdatePathTemplateReason;
    /**
     * Forbidden
     */
    403: ApiProblemDetailsOfUpdatePathTemplateReason;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfUpdatePathTemplateReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ModelingPathTemplatesByPathTemplateIdError = PutApiV1ModelingPathTemplatesByPathTemplateIdErrors[keyof PutApiV1ModelingPathTemplatesByPathTemplateIdErrors];

export type PutApiV1ModelingPathTemplatesByPathTemplateIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ModelingPathTemplatesByPathTemplateIdResponse = PutApiV1ModelingPathTemplatesByPathTemplateIdResponses[keyof PutApiV1ModelingPathTemplatesByPathTemplateIdResponses];

export type GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyData = {
    body?: never;
    path: {
        moduleKey: ModuleKey;
    };
    query?: never;
    url: '/api/v1/modeling/path-templates/containing-module/{moduleKey}';
};

export type GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyError = GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyErrors[keyof GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyErrors];

export type GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponses = {
    /**
     * OK
     */
    200: Array<PathTemplateModuleMembershipDto>;
};

export type GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponse = GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponses[keyof GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponses];

export type GetApiV1ModelingPathsData = {
    body?: never;
    path?: never;
    query?: {
        Offset?: number;
        Limit?: number;
        ClientID?: string;
        Status?: PathRunStatus;
    };
    url: '/api/v1/modeling/paths';
};

export type GetApiV1ModelingPathsErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathsError = GetApiV1ModelingPathsErrors[keyof GetApiV1ModelingPathsErrors];

export type GetApiV1ModelingPathsResponses = {
    /**
     * OK
     */
    200: EntityListOfPathRunListItemDto;
};

export type GetApiV1ModelingPathsResponse = GetApiV1ModelingPathsResponses[keyof GetApiV1ModelingPathsResponses];

export type PostApiV1ModelingPathsData = {
    body: StartPathRunCommandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/paths';
};

export type PostApiV1ModelingPathsErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfStartPathRunReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfStartPathRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsError = PostApiV1ModelingPathsErrors[keyof PostApiV1ModelingPathsErrors];

export type PostApiV1ModelingPathsResponses = {
    /**
     * OK
     */
    200: StartPathRunResult;
};

export type PostApiV1ModelingPathsResponse = PostApiV1ModelingPathsResponses[keyof PostApiV1ModelingPathsResponses];

export type GetApiV1ModelingPathsByPathRunIdData = {
    body?: never;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}';
};

export type GetApiV1ModelingPathsByPathRunIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathsByPathRunIdError = GetApiV1ModelingPathsByPathRunIdErrors[keyof GetApiV1ModelingPathsByPathRunIdErrors];

export type GetApiV1ModelingPathsByPathRunIdResponses = {
    /**
     * OK
     */
    200: PathRunDetailDto;
};

export type GetApiV1ModelingPathsByPathRunIdResponse = GetApiV1ModelingPathsByPathRunIdResponses[keyof GetApiV1ModelingPathsByPathRunIdResponses];

export type DeleteApiV1ModelingPathsByPathRunIdShareData = {
    body?: never;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/share';
};

export type DeleteApiV1ModelingPathsByPathRunIdShareErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfRevokePathRunShareReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ModelingPathsByPathRunIdShareError = DeleteApiV1ModelingPathsByPathRunIdShareErrors[keyof DeleteApiV1ModelingPathsByPathRunIdShareErrors];

export type DeleteApiV1ModelingPathsByPathRunIdShareResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ModelingPathsByPathRunIdShareResponse = DeleteApiV1ModelingPathsByPathRunIdShareResponses[keyof DeleteApiV1ModelingPathsByPathRunIdShareResponses];

export type PostApiV1ModelingPathsByPathRunIdShareData = {
    body?: never;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/share';
};

export type PostApiV1ModelingPathsByPathRunIdShareErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfSharePathRunReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfSharePathRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdShareError = PostApiV1ModelingPathsByPathRunIdShareErrors[keyof PostApiV1ModelingPathsByPathRunIdShareErrors];

export type PostApiV1ModelingPathsByPathRunIdShareResponses = {
    /**
     * OK
     */
    200: SharePathRunResult;
};

export type PostApiV1ModelingPathsByPathRunIdShareResponse = PostApiV1ModelingPathsByPathRunIdShareResponses[keyof PostApiV1ModelingPathsByPathRunIdShareResponses];

export type PostApiV1ModelingPathsByPathRunIdShareEmailData = {
    body?: never;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/share/email';
};

export type PostApiV1ModelingPathsByPathRunIdShareEmailErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfSendShareEmailReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfSendShareEmailReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdShareEmailError = PostApiV1ModelingPathsByPathRunIdShareEmailErrors[keyof PostApiV1ModelingPathsByPathRunIdShareEmailErrors];

export type PostApiV1ModelingPathsByPathRunIdShareEmailResponses = {
    /**
     * Accepted
     */
    202: unknown;
};

export type GetApiV1ModelingPathsPublicByPublicShareTokenData = {
    body?: never;
    path: {
        publicShareToken: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/public/{publicShareToken}';
};

export type GetApiV1ModelingPathsPublicByPublicShareTokenErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathsPublicByPublicShareTokenError = GetApiV1ModelingPathsPublicByPublicShareTokenErrors[keyof GetApiV1ModelingPathsPublicByPublicShareTokenErrors];

export type GetApiV1ModelingPathsPublicByPublicShareTokenResponses = {
    /**
     * OK
     */
    200: SharedPathRunDto;
};

export type GetApiV1ModelingPathsPublicByPublicShareTokenResponse = GetApiV1ModelingPathsPublicByPublicShareTokenResponses[keyof GetApiV1ModelingPathsPublicByPublicShareTokenResponses];

export type GetApiV1ModelingPathsByPathRunIdVersionsData = {
    body?: never;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/versions';
};

export type GetApiV1ModelingPathsByPathRunIdVersionsErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingPathsByPathRunIdVersionsError = GetApiV1ModelingPathsByPathRunIdVersionsErrors[keyof GetApiV1ModelingPathsByPathRunIdVersionsErrors];

export type GetApiV1ModelingPathsByPathRunIdVersionsResponses = {
    /**
     * OK
     */
    200: Array<PathRunVersionListItemDto>;
};

export type GetApiV1ModelingPathsByPathRunIdVersionsResponse = GetApiV1ModelingPathsByPathRunIdVersionsResponses[keyof GetApiV1ModelingPathsByPathRunIdVersionsResponses];

export type PostApiV1ModelingPathsByPathRunIdCloseData = {
    body?: never;
    path: {
        pathRunId: string;
    };
    query?: {
        currentClientEpoch?: number;
    };
    url: '/api/v1/modeling/paths/{pathRunId}/close';
};

export type PostApiV1ModelingPathsByPathRunIdCloseErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfClosePathRunReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfClosePathRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdCloseError = PostApiV1ModelingPathsByPathRunIdCloseErrors[keyof PostApiV1ModelingPathsByPathRunIdCloseErrors];

export type PostApiV1ModelingPathsByPathRunIdCloseResponses = {
    /**
     * OK
     */
    200: ClosePathRunResult;
};

export type PostApiV1ModelingPathsByPathRunIdCloseResponse = PostApiV1ModelingPathsByPathRunIdCloseResponses[keyof PostApiV1ModelingPathsByPathRunIdCloseResponses];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeData = {
    body: ToggleFieldBindingModeCommandRequest;
    path: {
        pathRunId: string;
        pathRunStepId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/steps/{pathRunStepId}/binding-mode';
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeError = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeErrors[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeErrors];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponses = {
    /**
     * OK
     */
    200: ToggleFieldBindingModeResult;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponse = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponses[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponses];

export type PostApiV1ModelingPathsByPathRunIdClientSummaryData = {
    body: SetPathRunClientSummaryRequest;
    path: {
        pathRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/client-summary';
};

export type PostApiV1ModelingPathsByPathRunIdClientSummaryErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdClientSummaryError = PostApiV1ModelingPathsByPathRunIdClientSummaryErrors[keyof PostApiV1ModelingPathsByPathRunIdClientSummaryErrors];

export type PostApiV1ModelingPathsByPathRunIdClientSummaryResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingPathsByPathRunIdClientSummaryResponse = PostApiV1ModelingPathsByPathRunIdClientSummaryResponses[keyof PostApiV1ModelingPathsByPathRunIdClientSummaryResponses];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryData = {
    body: SetPathStepClientSummaryRequest;
    path: {
        pathRunId: string;
        pathRunStepId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/steps/{pathRunStepId}/client-summary';
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryError = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryErrors[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryErrors];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponse = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponses[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponses];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsData = {
    body: SetPathStepInputsCommandRequest;
    path: {
        pathRunId: string;
        pathRunStepId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/steps/{pathRunStepId}/inputs';
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsError = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsErrors[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsErrors];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponses = {
    /**
     * OK
     */
    200: SetPathStepInputsResult;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponse = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponses[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponses];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsData = {
    body: SetPathStepOutputsCommandRequest;
    path: {
        pathRunId: string;
        pathRunStepId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/steps/{pathRunStepId}/outputs';
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsError = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsErrors[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsErrors];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponses = {
    /**
     * OK
     */
    200: SetPathStepOutputsResult;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponse = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponses[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponses];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseData = {
    body: SetPathStepFormResponseCommandRequest;
    path: {
        pathRunId: string;
        pathRunStepId: string;
    };
    query?: never;
    url: '/api/v1/modeling/paths/{pathRunId}/steps/{pathRunStepId}/form-response';
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfPathStepOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseError = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseErrors[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseErrors];

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponses = {
    /**
     * OK
     */
    200: SetPathStepFormResponseResult;
};

export type PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponse = PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponses[keyof PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponses];

export type GetApiV1ModelingCustomModulesData = {
    body?: never;
    path?: never;
    query?: {
        Offset?: number;
        Limit?: number;
        Scope?: OwnershipScope;
        Kind?: CustomModuleKind;
        Search?: string;
    };
    url: '/api/v1/modeling/custom-modules';
};

export type GetApiV1ModelingCustomModulesErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingCustomModulesError = GetApiV1ModelingCustomModulesErrors[keyof GetApiV1ModelingCustomModulesErrors];

export type GetApiV1ModelingCustomModulesResponses = {
    /**
     * OK
     */
    200: EntityListOfCustomModuleListItemDto;
};

export type GetApiV1ModelingCustomModulesResponse = GetApiV1ModelingCustomModulesResponses[keyof GetApiV1ModelingCustomModulesResponses];

export type PostApiV1ModelingCustomModulesData = {
    body: CreateCustomModuleCommandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/custom-modules';
};

export type PostApiV1ModelingCustomModulesErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfCreateCustomModuleReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfCreateCustomModuleReason;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfCreateCustomModuleReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingCustomModulesError = PostApiV1ModelingCustomModulesErrors[keyof PostApiV1ModelingCustomModulesErrors];

export type PostApiV1ModelingCustomModulesResponses = {
    /**
     * OK
     */
    200: CreateCustomModuleResult;
};

export type PostApiV1ModelingCustomModulesResponse = PostApiV1ModelingCustomModulesResponses[keyof PostApiV1ModelingCustomModulesResponses];

export type DeleteApiV1ModelingCustomModulesByCustomModuleIdData = {
    body?: never;
    path: {
        customModuleId: string;
    };
    query?: never;
    url: '/api/v1/modeling/custom-modules/{customModuleId}';
};

export type DeleteApiV1ModelingCustomModulesByCustomModuleIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfDeleteCustomModuleReason;
    /**
     * Forbidden
     */
    403: ApiProblemDetailsOfDeleteCustomModuleReason;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfDeleteCustomModuleReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfDeleteCustomModuleReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ModelingCustomModulesByCustomModuleIdError = DeleteApiV1ModelingCustomModulesByCustomModuleIdErrors[keyof DeleteApiV1ModelingCustomModulesByCustomModuleIdErrors];

export type DeleteApiV1ModelingCustomModulesByCustomModuleIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ModelingCustomModulesByCustomModuleIdResponse = DeleteApiV1ModelingCustomModulesByCustomModuleIdResponses[keyof DeleteApiV1ModelingCustomModulesByCustomModuleIdResponses];

export type GetApiV1ModelingCustomModulesByCustomModuleIdData = {
    body?: never;
    path: {
        customModuleId: string;
    };
    query?: never;
    url: '/api/v1/modeling/custom-modules/{customModuleId}';
};

export type GetApiV1ModelingCustomModulesByCustomModuleIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingCustomModulesByCustomModuleIdError = GetApiV1ModelingCustomModulesByCustomModuleIdErrors[keyof GetApiV1ModelingCustomModulesByCustomModuleIdErrors];

export type GetApiV1ModelingCustomModulesByCustomModuleIdResponses = {
    /**
     * OK
     */
    200: CustomModuleDetailDto;
};

export type GetApiV1ModelingCustomModulesByCustomModuleIdResponse = GetApiV1ModelingCustomModulesByCustomModuleIdResponses[keyof GetApiV1ModelingCustomModulesByCustomModuleIdResponses];

export type PutApiV1ModelingCustomModulesByCustomModuleIdData = {
    body: UpdateCustomModuleCommandRequest;
    path: {
        customModuleId: string;
    };
    query?: never;
    url: '/api/v1/modeling/custom-modules/{customModuleId}';
};

export type PutApiV1ModelingCustomModulesByCustomModuleIdErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfUpdateCustomModuleReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfUpdateCustomModuleReason;
    /**
     * Forbidden
     */
    403: ApiProblemDetailsOfUpdateCustomModuleReason;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfUpdateCustomModuleReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PutApiV1ModelingCustomModulesByCustomModuleIdError = PutApiV1ModelingCustomModulesByCustomModuleIdErrors[keyof PutApiV1ModelingCustomModulesByCustomModuleIdErrors];

export type PutApiV1ModelingCustomModulesByCustomModuleIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1ModelingCustomModulesByCustomModuleIdResponse = PutApiV1ModelingCustomModulesByCustomModuleIdResponses[keyof PutApiV1ModelingCustomModulesByCustomModuleIdResponses];

export type GetApiV1ModelingModulesCatalogData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/modules/catalog';
};

export type GetApiV1ModelingModulesCatalogErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingModulesCatalogError = GetApiV1ModelingModulesCatalogErrors[keyof GetApiV1ModelingModulesCatalogErrors];

export type GetApiV1ModelingModulesCatalogResponses = {
    /**
     * OK
     */
    200: Array<ModuleCatalogEntryDto>;
};

export type GetApiV1ModelingModulesCatalogResponse = GetApiV1ModelingModulesCatalogResponses[keyof GetApiV1ModelingModulesCatalogResponses];

export type GetApiV1ModelingModuleRunsData = {
    body?: never;
    path?: never;
    query?: {
        Offset?: number;
        Limit?: number;
        ClientID?: string;
        ModuleKey?: ModuleKey;
    };
    url: '/api/v1/modeling/module-runs';
};

export type GetApiV1ModelingModuleRunsErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingModuleRunsError = GetApiV1ModelingModuleRunsErrors[keyof GetApiV1ModelingModuleRunsErrors];

export type GetApiV1ModelingModuleRunsResponses = {
    /**
     * OK
     */
    200: EntityListOfModuleRunListItemDto;
};

export type GetApiV1ModelingModuleRunsResponse = GetApiV1ModelingModuleRunsResponses[keyof GetApiV1ModelingModuleRunsResponses];

export type PostApiV1ModelingModuleRunsData = {
    body: StartModuleRunCommandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/module-runs';
};

export type PostApiV1ModelingModuleRunsErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfStartModuleRunReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfStartModuleRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsError = PostApiV1ModelingModuleRunsErrors[keyof PostApiV1ModelingModuleRunsErrors];

export type PostApiV1ModelingModuleRunsResponses = {
    /**
     * OK
     */
    200: StartModuleRunResult;
};

export type PostApiV1ModelingModuleRunsResponse = PostApiV1ModelingModuleRunsResponses[keyof PostApiV1ModelingModuleRunsResponses];

export type GetApiV1ModelingModuleRunsByModuleRunIdData = {
    body?: never;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}';
};

export type GetApiV1ModelingModuleRunsByModuleRunIdErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingModuleRunsByModuleRunIdError = GetApiV1ModelingModuleRunsByModuleRunIdErrors[keyof GetApiV1ModelingModuleRunsByModuleRunIdErrors];

export type GetApiV1ModelingModuleRunsByModuleRunIdResponses = {
    /**
     * OK
     */
    200: ModuleRunDetailDto;
};

export type GetApiV1ModelingModuleRunsByModuleRunIdResponse = GetApiV1ModelingModuleRunsByModuleRunIdResponses[keyof GetApiV1ModelingModuleRunsByModuleRunIdResponses];

export type DeleteApiV1ModelingModuleRunsByModuleRunIdShareData = {
    body?: never;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/share';
};

export type DeleteApiV1ModelingModuleRunsByModuleRunIdShareErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfRevokeModuleRunShareReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type DeleteApiV1ModelingModuleRunsByModuleRunIdShareError = DeleteApiV1ModelingModuleRunsByModuleRunIdShareErrors[keyof DeleteApiV1ModelingModuleRunsByModuleRunIdShareErrors];

export type DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponse = DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponses[keyof DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdShareData = {
    body?: never;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/share';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdShareErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfShareModuleRunReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfShareModuleRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdShareError = PostApiV1ModelingModuleRunsByModuleRunIdShareErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdShareErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdShareResponses = {
    /**
     * OK
     */
    200: ShareModuleRunResult;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdShareResponse = PostApiV1ModelingModuleRunsByModuleRunIdShareResponses[keyof PostApiV1ModelingModuleRunsByModuleRunIdShareResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdShareEmailData = {
    body?: never;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/share/email';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdShareEmailErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfSendShareEmailReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfSendShareEmailReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdShareEmailError = PostApiV1ModelingModuleRunsByModuleRunIdShareEmailErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdShareEmailErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdShareEmailResponses = {
    /**
     * Accepted
     */
    202: unknown;
};

export type GetApiV1ModelingModuleRunsPublicByPublicShareTokenData = {
    body?: never;
    path: {
        publicShareToken: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/public/{publicShareToken}';
};

export type GetApiV1ModelingModuleRunsPublicByPublicShareTokenErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingModuleRunsPublicByPublicShareTokenError = GetApiV1ModelingModuleRunsPublicByPublicShareTokenErrors[keyof GetApiV1ModelingModuleRunsPublicByPublicShareTokenErrors];

export type GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponses = {
    /**
     * OK
     */
    200: SharedModuleRunDto;
};

export type GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponse = GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponses[keyof GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdCloseData = {
    body?: never;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/close';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdCloseErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfCloseModuleRunReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfCloseModuleRunReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfCloseModuleRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdCloseError = PostApiV1ModelingModuleRunsByModuleRunIdCloseErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdCloseErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdCloseResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdCloseResponse = PostApiV1ModelingModuleRunsByModuleRunIdCloseResponses[keyof PostApiV1ModelingModuleRunsByModuleRunIdCloseResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdReopenData = {
    body?: never;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/reopen';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdReopenErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfReopenModuleRunReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfReopenModuleRunReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfReopenModuleRunReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdReopenError = PostApiV1ModelingModuleRunsByModuleRunIdReopenErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdReopenErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdReopenResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdReopenResponse = PostApiV1ModelingModuleRunsByModuleRunIdReopenResponses[keyof PostApiV1ModelingModuleRunsByModuleRunIdReopenResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryData = {
    body: SetModuleRunClientSummaryRequest;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/client-summary';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryError = PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponse = PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponses[keyof PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdInputsData = {
    body: JsonElement;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/inputs';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdInputsErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdInputsError = PostApiV1ModelingModuleRunsByModuleRunIdInputsErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdInputsErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdInputsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdInputsResponse = PostApiV1ModelingModuleRunsByModuleRunIdInputsResponses[keyof PostApiV1ModelingModuleRunsByModuleRunIdInputsResponses];

export type PostApiV1ModelingModuleRunsByModuleRunIdOutputsData = {
    body: JsonElement;
    path: {
        moduleRunId: string;
    };
    query?: never;
    url: '/api/v1/modeling/module-runs/{moduleRunId}/outputs';
};

export type PostApiV1ModelingModuleRunsByModuleRunIdOutputsErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Conflict
     */
    409: ApiProblemDetailsOfModuleRunOperationReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdOutputsError = PostApiV1ModelingModuleRunsByModuleRunIdOutputsErrors[keyof PostApiV1ModelingModuleRunsByModuleRunIdOutputsErrors];

export type PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponse = PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponses[keyof PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponses];

export type GetApiV1ModelingFormsPaletteData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/forms/palette';
};

export type GetApiV1ModelingFormsPaletteErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingFormsPaletteError = GetApiV1ModelingFormsPaletteErrors[keyof GetApiV1ModelingFormsPaletteErrors];

export type GetApiV1ModelingFormsPaletteResponses = {
    /**
     * OK
     */
    200: FormPaletteDto;
};

export type GetApiV1ModelingFormsPaletteResponse = GetApiV1ModelingFormsPaletteResponses[keyof GetApiV1ModelingFormsPaletteResponses];

export type GetApiV1ModelingFormsCountriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/forms/countries';
};

export type GetApiV1ModelingFormsCountriesErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1ModelingFormsCountriesError = GetApiV1ModelingFormsCountriesErrors[keyof GetApiV1ModelingFormsCountriesErrors];

export type GetApiV1ModelingFormsCountriesResponses = {
    /**
     * OK
     */
    200: Array<CountryOptionDto>;
};

export type GetApiV1ModelingFormsCountriesResponse = GetApiV1ModelingFormsCountriesResponses[keyof GetApiV1ModelingFormsCountriesResponses];

export type PostApiV1ModelingAiClientSummaryData = {
    body: GenerateClientSummaryRequest;
    path?: never;
    query?: never;
    url: '/api/v1/modeling/ai/client-summary';
};

export type PostApiV1ModelingAiClientSummaryErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfAiCompletionErrorReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetailsOfAiCompletionErrorReason;
    /**
     * Too Many Requests
     */
    429: ApiProblemDetailsOfAiCompletionErrorReason;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1ModelingAiClientSummaryError = PostApiV1ModelingAiClientSummaryErrors[keyof PostApiV1ModelingAiClientSummaryErrors];

export type PostApiV1ModelingAiClientSummaryResponses = {
    /**
     * OK
     */
    200: GenerateClientSummaryResult;
};

export type PostApiV1ModelingAiClientSummaryResponse = PostApiV1ModelingAiClientSummaryResponses[keyof PostApiV1ModelingAiClientSummaryResponses];

export type PostApiV1FilesData = {
    body: {
        File?: IFormFile;
        Context?: FileUploadContext;
    };
    path?: never;
    query?: never;
    url: '/api/v1/files';
};

export type PostApiV1FilesErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfUploadFileError;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1FilesError = PostApiV1FilesErrors[keyof PostApiV1FilesErrors];

export type PostApiV1FilesResponses = {
    /**
     * OK
     */
    200: UploadFileResult;
};

export type PostApiV1FilesResponse = PostApiV1FilesResponses[keyof PostApiV1FilesResponses];

export type GetApiV1FilesByPublicTokenContentData = {
    body?: never;
    path: {
        publicToken: string;
    };
    query?: never;
    url: '/api/v1/files/{publicToken}/content';
};

export type GetApiV1FilesByPublicTokenContentErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ApiProblemDetailsOfGetFileContentError;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1FilesByPublicTokenContentError = GetApiV1FilesByPublicTokenContentErrors[keyof GetApiV1FilesByPublicTokenContentErrors];

export type GetApiV1FilesByPublicTokenContentResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetApiV1ClientsExternalData = {
    body?: never;
    path?: never;
    query?: {
        Offset?: number;
        Limit?: number;
        Search?: string;
    };
    url: '/api/v1/clients/external';
};

export type GetApiV1ClientsExternalErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfSabApiErrorReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
    /**
     * Bad Gateway
     */
    502: ApiProblemDetailsOfSabApiErrorReason;
};

export type GetApiV1ClientsExternalError = GetApiV1ClientsExternalErrors[keyof GetApiV1ClientsExternalErrors];

export type GetApiV1ClientsExternalResponses = {
    /**
     * OK
     */
    200: SearchSabClientsResponse;
};

export type GetApiV1ClientsExternalResponse = GetApiV1ClientsExternalResponses[keyof GetApiV1ClientsExternalResponses];

export type GetApiV1ClientsExternalByPersonalNumberData = {
    body?: never;
    path: {
        personalNumber: string;
    };
    query?: never;
    url: '/api/v1/clients/external/{personalNumber}';
};

export type GetApiV1ClientsExternalByPersonalNumberErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfSabApiErrorReason;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
    /**
     * Bad Gateway
     */
    502: ApiProblemDetailsOfSabApiErrorReason;
};

export type GetApiV1ClientsExternalByPersonalNumberError = GetApiV1ClientsExternalByPersonalNumberErrors[keyof GetApiV1ClientsExternalByPersonalNumberErrors];

export type GetApiV1ClientsExternalByPersonalNumberResponses = {
    /**
     * OK
     */
    200: SabClientDetailDto;
};

export type GetApiV1ClientsExternalByPersonalNumberResponse = GetApiV1ClientsExternalByPersonalNumberResponses[keyof GetApiV1ClientsExternalByPersonalNumberResponses];

export type PostApiV1AuthSignInData = {
    body: SignInCommandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/sign-in';
};

export type PostApiV1AuthSignInErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfAuthError;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthSignInError = PostApiV1AuthSignInErrors[keyof PostApiV1AuthSignInErrors];

export type PostApiV1AuthSignInResponses = {
    /**
     * OK
     */
    200: SignInResult;
};

export type PostApiV1AuthSignInResponse = PostApiV1AuthSignInResponses[keyof PostApiV1AuthSignInResponses];

export type PostApiV1AuthBrokerSignInData = {
    body: BrokerSignInCommandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/broker-sign-in';
};

export type PostApiV1AuthBrokerSignInErrors = {
    /**
     * Bad Request
     */
    400: ApiProblemDetailsOfAuthError;
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type PostApiV1AuthBrokerSignInError = PostApiV1AuthBrokerSignInErrors[keyof PostApiV1AuthBrokerSignInErrors];

export type PostApiV1AuthBrokerSignInResponses = {
    /**
     * OK
     */
    200: SignInResult;
};

export type PostApiV1AuthBrokerSignInResponse = PostApiV1AuthBrokerSignInResponses[keyof PostApiV1AuthBrokerSignInResponses];

export type GetApiV1AuthUserinfoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/userinfo';
};

export type GetApiV1AuthUserinfoErrors = {
    /**
     * Unauthorized
     */
    401: ApiProblemDetails;
    /**
     * Internal Server Error
     */
    500: ProblemDetails;
};

export type GetApiV1AuthUserinfoError = GetApiV1AuthUserinfoErrors[keyof GetApiV1AuthUserinfoErrors];

export type GetApiV1AuthUserinfoResponses = {
    /**
     * OK
     */
    200: UserInfo;
};

export type GetApiV1AuthUserinfoResponse = GetApiV1AuthUserinfoResponses[keyof GetApiV1AuthUserinfoResponses];
